import $ from 'jquery';

import app from './app';

import './jquery/jquery.placeholder';
import './jquery/jquery.imageFallback';
import './jquery/jquery.nextElementInDom';

// config and page model are set in HTML file
const { config, pageModel } = window.POne;

app.config = JSON.parse(JSON.stringify(config));
app.pageModel = JSON.parse(JSON.stringify(pageModel));
app.rootElement = $('body');
app.init();

$(() => {
    // placeholder functionality for older browsers
    $('input[placeholder]').placeholder();

    // fallback image on image load errors
    $('img[data-fallback-src]').imageFallback();

    // display page content if everything is initialized
    $('#main > article').show();
});

// Button goes through all available areas
$(document).bind('keydown', 'g', function focusNextElementGlobalarea() {
    const focusElement = $(':focus');
    if (focusElement.prop('tagName').toLowerCase() !== 'input') {
        if (focusElement.length > 0) {
            // There is an element focused
            const nextElementInDom = focusElement.nextElementInDom('[data-areaindex~="globalarea"]', true);
            nextElementInDom.focus();
        } else {
            // No element is focused, so let's start at the beginning
            const nextElementInDom = $('body').nextElementInDom('[data-areaindex~="globalarea"]', true);
            nextElementInDom.focus();
        }
        return false;
    }
    return true;
});

// Button goes through all content areas
$(document).bind('keydown', 'alt+g', function focusNextElementAltContentarea() {
    const focusElement = $(':focus');
    if (focusElement.length > 0) {
        // There is an element focused
        const nextElementInDom = focusElement.nextElementInDom('[data-areaindex~="contentarea"]', true);
        nextElementInDom.focus();
    } else {
        // No element is focused, so let's start at the beginning
        const nextElementInDom = $('body').nextElementInDom('[data-areaindex~="contentarea"]', true);
        nextElementInDom.focus();
    }
    return false;
});

// Button focusses the navigation area
$(document).bind('keydown', 'alt+m', function focusNextElementAltContentarea() {
    const focusElement = $(':focus');
    if (focusElement.length > 0) {
        // There is an element focused
        const nextElementInDom = focusElement.nextElementInDom('[data-areaindex~="navigationarea"]', true);
        nextElementInDom.focus();
    } else {
        // No element is focused, so let's start at the beginning
        const nextElementInDom = $('body').nextElementInDom('[data-areaindex~="navigationarea"]', true);
        nextElementInDom.focus();
    }
    return false;
});

//reportValidity polyfill
if (!HTMLFormElement.prototype.reportValidity) {
    const ALERT_ID = 'validationMessage';
    HTMLFormElement.prototype.reportValidity = function () {
        if (!this.checkValidity()) {
            if ($(this).find($(`#${ALERT_ID}`)).length === 0) {
                const title = window.POne.pageModel.i18n.messages['general.validationError'];
                const alert = $('<div>', {
                    id: ALERT_ID,
                    class: 'alert alert-warning'
                }).html(title);
                $(this).append(alert);
            }

            return false;
        }

        $(this).find(`#${ALERT_ID}`)
            .remove();

        return true;
    };
}


$.ajaxPrefilter(function (opts) {
    if (opts.type === 'GET') {
        return;
    }
    if (opts.data) {
        opts.data += '&';
    } else {
        opts.data = '';
    }
    opts.data += `${$('meta[name="_csrf_name"]').attr('content')}=${$('meta[name="_csrf_token"]').attr('content')}`;
});

$.ajaxPrefilter(function (opts) {
    if (opts.type === 'DELETE') {
        opts.type = 'POST';
        if (opts.data) {
            opts.data += '&';
        } else {
            opts.data = '';
        }
        opts.data += '_method=DELETE';
    }
});



// WEBPACK FOOTER //
// ./index.js